import { useCallback, useEffect, useState } from "react";
import { getRecruitment } from "../../../api/recruiment";
import { LEVEL_OPTIONS } from "../../../enums/recruitment";
import bg_banner from "../../../assets/images/bg_recruitment.webp";
import RecruitmentGridItem from "../recruitment-grid-item";
import RecruitmentItem from "../recruitment-item";
import RecruitmentPagination from "../recruitment-pagination";
import RecruitmentToolbar from "../recruitment-toolbar";
import RecruitmentSetReminder from "../recruitment-set-reminder";
import { MenuItem, Select } from "@mui/material";
import FilterPosition from "../components/filter-postition";
import FilterAddress from "../components/filter-address";
import GroupButtonViewToggle from "../components/group-button-view-toggle";

// -----------------------------------------------------------

const initialFilters = {
  page: 1,
  pageSize: 9,
  keyword: "",
  position: 0,
  address: "all",
  level: 0,
};

const initSortValue = "newest";

export default function Recruitment() {
  const [recruitments, setRecruiments] = useState([]);
  const [filters, setFilters] = useState(initialFilters);
  const [searchParams, setSearchParams] = useState(initialFilters);
  const [totalRecord, setTotalRecord] = useState(0);
  const [view, setView] = useState("grid");
  const [sortValue, setSortValue] = useState(initSortValue);

  const handleUpdateFilters = useCallback((key, value) => {
    setFilters((prev) => ({ ...prev, [key]: value }));
  }, []);

  const start = (searchParams.page - 1) * searchParams.pageSize + 1;
  const end = Math.min(searchParams.page * searchParams.pageSize, totalRecord);

  const handleSearch = useCallback(() => {
    setSearchParams((prev) => ({
      ...prev,
      keyword: filters.keyword,
      position: filters.position,
      level: filters.level,
      address: filters.address,
    }));
  }, [filters]);

  const handleUpdateSearchParam = useCallback((key, value) => {
    setSearchParams((prev) => ({ ...prev, [key]: value }));
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      const { code, data } = await getRecruitment(searchParams);
      if (code === 1) {
        setRecruiments(data.data);
        setTotalRecord(data.totalRecord);
      }
    };
    fetchData();
  }, [searchParams]);

  const dataFilterd = applyFilter(sortValue, recruitments);

  return (
    <div className="lg:pt-[120px] pt-[72px] w-full">
      <div
        className="h-[620px] md:h-[369px] relative object-contain"
        style={{
          background: `linear-gradient(90deg, rgba(39, 198, 255, 0.90) 0%, rgba(19, 117, 183, 0.90) 100%), url(${bg_banner})`,
          backgroundColor: "lightgray",
          backgroundPosition: "0px -255.567px",
          backgroundSize: "100% 337.18%",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div className="container px-4 max-w-7xl mx-auto absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
          <div className="px-4 py-2 bg-white rounded-[40px] self-start inline-flex gap-3">
            <img
              src="/assets/icons/ic_home.svg"
              className="w-[22px] h-[22px]"
            />
            <img
              src="/assets/icons/ic_arrow_right.svg"
              className="w-[22px] h-[22px]"
            />
            <p className="text-[#1375B7]">Tuyển dụng</p>
          </div>
          <p className="text-[24px] md:text-[28px] text-white font-semibold my-2">
            “Gia nhập đội ngũ của chúng tôi - Cùng xây dựng tương lai công nghệ"
          </p>
          <p className="text-white">
            Hiện có {totalRecord} việc làm tại đây dành cho bạn!
          </p>
          <RecruitmentToolbar
            filters={filters}
            handleUpdateFilters={handleUpdateFilters}
            handleSearch={handleSearch}
          />
        </div>
      </div>
      <div className="container px-4 sm:max-w-7xl mx-auto py-9">
        <div className="grid grid-cols-12 md:gap-9">
          <div className="hidden md:block col-span-12 md:col-span-3">
            <RecruitmentSetReminder />
            <div
              className="bg-white px-4 py-6 mt-7 rounded-lg"
              style={{ boxShadow: "0px 2px 4.8px 0px rgba(0, 0, 0, 0.10)" }}
            >
              <div>
                <p className="text-[#033F6A] text-[18px] font-semibold mb-4">
                  Vị trí ứng tuyển
                </p>
                <FilterPosition
                  value={searchParams.position}
                  onChange={(value) =>
                    handleUpdateSearchParam("position", value)
                  }
                />
              </div>

              <div className="mt-5">
                <p className="text-[#033F6A] text-[18px] font-semibold mb-4">
                  Nơi làm việc
                </p>
                <FilterAddress
                  value={filters.address}
                  onChange={(value) =>
                    handleUpdateSearchParam("address", value)
                  }
                />
              </div>

              <div className="mt-5">
                <p className="text-[#033F6A] text-[18px] font-semibold">
                  Cấp bậc
                </p>
                <Select
                  onChange={(event) =>
                    handleUpdateSearchParam("level", +event.target.value)
                  }
                  className="flex-1 mt-4"
                  fullWidth
                  value={searchParams.level}
                >
                  {LEVEL_OPTIONS.map((item) => (
                    <MenuItem key={item.value} value={item.value}>
                      {item.title}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </div>
          </div>

          <div className="col-span-12 md:col-span-9">
            {dataFilterd.length > 0 && (
              <div className="flex flex-col md:flex-row md:items-center md:justify-between">
                <p>
                  Hiển thị{" "}
                  <b>
                    {start} - {end}
                  </b>{" "}
                  trên <b>{totalRecord}</b> công việc
                </p>
                <div className="flex justify-between items-center gap-4 mt-4">
                  <div className="flex items-center gap-4">
                    <p>Sắp xếp: </p>
                    <Select
                      onChange={(event) => setSortValue(event.target.value)}
                      sx={{ width: 130 }}
                      size="small"
                      value={sortValue}
                    >
                      <MenuItem value="newest">Mới nhất</MenuItem>
                      <MenuItem value="old">Cũ</MenuItem>
                      <MenuItem value="hot">Phổ biến</MenuItem>
                    </Select>
                  </div>
                  <GroupButtonViewToggle view={view} setView={setView} />
                </div>
              </div>
            )}

            {dataFilterd.length > 0 ? (
              <>
                {view === "grid" && (
                  <div className="mt-[30px] grid grid-cols-12 gap-6">
                    {dataFilterd.map((item) => (
                      <div key={item.id} className="col-span-12 md:col-span-4">
                        <RecruitmentGridItem item={item} />
                      </div>
                    ))}
                  </div>
                )}
                {view === "list" && (
                  <div className="mt-[30px] flex flex-col gap-y-4">
                    {dataFilterd.map((item) => (
                      <RecruitmentItem key={item.id} item={item} />
                    ))}
                  </div>
                )}
              </>
            ) : (
              <p>Hiện chưa có vị trí nào phù hợp</p>
            )}

            <div className="w-full h-[1px] bg-[#F1F0F0] mt-6"></div>
            {dataFilterd.length > 0 && (
              <RecruitmentPagination
                totalPage={Math.ceil(totalRecord / searchParams.pageSize)}
                pageCurrent={searchParams.page}
                onChangePage={(value) =>
                  setSearchParams((prev) => ({ ...prev, page: value }))
                }
              />
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

const applyFilter = (sortValue, inputData) => {
  if (sortValue === "newest") {
    inputData.sort(
      (a, b) =>
        new Date(b.publishTime).getTime() - new Date(a.publishTime).getTime()
    );
  }
  if (sortValue === "old") {
    inputData.sort(
      (a, b) =>
        new Date(a.publishTime).getTime() - new Date(b.publishTime).getTime()
    );
  }
  if (sortValue === "hot") {
    inputData = inputData.filter((recruit) => recruit.isHot);
  }
  return inputData;
};
